import { cn } from '@/lib/utils';
import { Buildings as BuildingsIcon } from '@phosphor-icons/react';
import useCustomer from 'src/api/accounts-receivable/customers/useCustomer';

interface CustomerPillProps {
  customer?: {
    name: string;
    erpDisplayName?: string | null;
    emailDomain?: string;
    phoneNumber?: string;
  };
  customerId?: string;
  onClick?: () => void;
  showERPDisplayName?: boolean;
}

export function CustomerPill({
  customer: providedCustomer,
  customerId,
  onClick,
  showERPDisplayName = false,
}: CustomerPillProps) {
  const { data: customerData, isLoading } = useCustomer(customerId, {});

  const customer = (providedCustomer ||
    customerData?.customer) as CustomerPillProps['customer'];

  const displayName =
    showERPDisplayName && customer
      ? (customer.erpDisplayName ?? customer.name)
      : customer?.name;

  if (isLoading || !customer) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1',
          'rounded-full px-2 py-0.5',
          'bg-blue-50 text-blue-600',
          'text-xs',
        )}
      >
        Loading...
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1',
        'rounded-full px-2 py-0.5',
        'bg-blue-50 text-blue-600',
        'text-xs',
        'transition-all duration-200 ease-in-out',
        onClick && [
          'cursor-pointer',
          'hover:bg-blue-100 hover:-translate-y-px hover:shadow-sm',
          'active:translate-y-0 active:shadow-none',
        ],
      )}
      onClick={onClick}
    >
      <BuildingsIcon className="size-4" />
      {displayName}
    </span>
  );
}

export default CustomerPill;
